import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'accuracyCountString',
    standalone: false
})
export class AccuracyCountStringPipe implements PipeTransform {

    transform(value: number, pluralLabel: string = '', singularLabel: string = ''): string {
        const strValue = (value > 1000000) ? '1M+' : value.toLocaleString();
        return `${strValue} ${value === 1 ? singularLabel : pluralLabel}`;
    }
}
